export default __webpack_public_path__ + "static/brown-stadium-small-6ee08a32f2749ddb41fed8a6c6ebc5d5.jpg";